@if ((endorsementStatus | async).completedActions === (endorsementStatus | async).totalActions || (endorsementStatus | async).totalActions === 0) {
  <div class="check-icon__completed"></div>
} @else {
  <div class="check-icon__action-required"></div>
}
